import React, {useEffect, useState} from 'react';
import "../style/full_info.scss"
import axios from "axios";
import {ApiNameGrant} from "../APIname";
import {toast} from "react-toastify";
import {Modal,Space, Table, Tag} from 'antd';


//img
import LOGOWIGHT from "../img/LOGOWIGHT.svg";
import user from "../img/user.png";
import Fakulty from "../img/fakulty.png";
import diraction from "../img/direction.png";
import course from "../img/course.png";
import group from "../img/group.png";
import data from "../img/data.png";
import location from "../img/location.png";
import cashEdu from "../img/cashEdu.png";
import GPA from "../img/GPA.png";
import ModalForma from "../componenta/modalForma";
import LanguageSwitcher from "../componenta/LanguageSwitcher";
import {useTranslation} from "react-i18next";
import Tabelhistory from "../componenta/tabelhistory";

function FulInfo() {
    const { t } = useTranslation();
    const [profilInfo, setProfilInfo] = useState()
    const [token] = useState(JSON.parse(localStorage.getItem("myCat")));
    const [message, setMessage] = useState('');
    const [isModalOpen, setIsModalOpen] = useState(false);
    useEffect(() => {
        profile()
        notify();
        setMessage('')
    },[message, isModalOpen]);

    function profile() {
        axios.get(`${ApiNameGrant}/api/profile/current`,{
            headers: {"Authorization": `Bearer ${token}`},"ngrok-skip-browser-warning": "69420",})
            .then(r => {
                setProfilInfo(r?.data?.data);
            })
            .catch(e => {
                console.log(e)
            })
    }

    const showModal = () => {
        if (profilInfo?.avg_gpa > 3){
            
            // if (profilInfo?.applications.length>0){
            //     setMessage("Siz allaqachon grant olish uchun ariza bergansiz! Boshqa ariza berish mumkin emas.");
            // }
            // else {
            //     setIsModalOpen(true)
            // }
            setIsModalOpen(true)
        }else if (profilInfo?.avg_gpa > 5){
            setMessage("GPA ball 3.5 va 5 orasda bolishi kerak!");
        }
        else {
            setMessage("Grant olish uchun ariza berish GPA 3.5 dan yuqori bo'lishi kerak! Qo'shimcha ma'lumot uchun bosh bino 110-xonaga murojaat qiling.",);

        }
    };
    const handleCancel = () => {
        setIsModalOpen(false);
    };
    function notify() {
        if (message.trim().length > 0 ){
            toast.warning(message)
        }
    }

    return (
        <div className="fullInfo" id='myElement'>
            <div className="header">
               <div className="title text-uppercase w-50">
                   {t("Home.logo1")}<br/>
                   {t("Home.logo2")}
               </div>
                <img className='logo' src={LOGOWIGHT} alt=""/>
            </div>
            <div className="UserNameBox">
                {profilInfo?.imageUrl !== '' && profilInfo?.imageUrl != null  ?
                      <img className='user' src={profilInfo?.imageUrl} alt=""/>
                      :
                      <img className='user' src={user} alt=""/>
                }

                <div className="NameInfo">
                    <span> {profilInfo?.fullName}</span>
                    <p>{profilInfo?.studentIdNumber}</p>
                </div>
            </div>
            <div className="ButtonBox d-flex justify-content-between">
                <div className="d-flex">
                    <button className="btn btn1">Shaxsiy ma’lumotlar</button>
                    <button className="btn btn1">
                        <a href="https://student.tdtu.uz/dashboard/login" target="_blank" rel="noreferrer">HEMIS</a>
                    </button>
                    <button className="btn btn1">
                        <a href="https://t.me/rofficetdtu_bot" target="_blank" rel="noreferrer">Telegram bot</a>
                    </button>
                        <LanguageSwitcher />
                </div>

                <button className="btn btn1" onClick={showModal}>
                    Davlat granti olish
                </button>
            </div>
            <Modal
                title="Grant olish uchun ariza"
                width={800}
                open={isModalOpen}
                onCancel={handleCancel}
                footer={null}
            >

                <ModalForma handleCancel={handleCancel} user={profilInfo}/>
            </Modal>

            <div className="container-fluid">
                <div className="row">
                    <div className="col-12 FISHbox">
                        <div className="FISH">
                            <div className="infoBox">
                                <div className="left">
                                    <img src={Fakulty} alt=""/>
                                    Fakultet
                                </div>
                                <div className="righte">{profilInfo?.departmentInfo?.name}</div>
                            </div>
                            <div className="infoBox">
                                <div className="left">
                                    <img src={diraction} alt=""/>
                                    Yo'nalish
                                </div>
                                <div className="righte">{profilInfo?.specialtyInfo?.name}</div>
                            </div>
                            <div className="infoBox">
                                <div className="left">
                                    <img src={course} alt=""/>
                                    Kurs
                                </div>
                                <div className="righte">{profilInfo?.levelInfo?.name}</div>
                            </div>
                            <div className="infoBox">
                                <div className="left">
                                    <img src={group} alt=""/>
                                    Guruh
                                </div>
                                <div className="righte">{profilInfo?.groupInfo?.name}</div>
                            </div>
                            <div className="infoBox">
                                <div className="left">
                                    <img src={cashEdu} alt=""/>
                                    To'lov shakli
                                </div>
                                <div className="righte">{profilInfo?.paymentFormInfo?.name}</div>
                            </div>
                            <div className="infoBox">
                                <div className="left">
                                    <img src={GPA} alt=""/>
                                    GPA
                                </div>
                                <div className="righte">{profilInfo?.avg_gpa}</div>
                            </div>
                            <div className="infoBox">
                                <div className="left">
                                    <img src={data} alt=""/>
                                    Tug’ilgan yil
                                </div>
                                <div className="righte">{profilInfo?.birth_date}</div>
                            </div>
                            <div className="infoBox">
                                <div className="left">
                                    <img src={location} alt=""/>
                                    Manzil
                                </div>
                                <div className="righte">{profilInfo?.country_info?.name} {profilInfo?.province_info?.name} {profilInfo?.district_info?.name}</div>
                            </div>
                            <div className="infoBox">
                                <div className="left">
                                    <img src={Fakulty} alt=""/>
                                    Ta`lim darajasi
                                </div>
                                <div className="righte">{profilInfo?.education_type_info?.name}</div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <Tabelhistory userInfo={profilInfo?.applications}/>

        </div>
    );
}

export default FulInfo;